"use client";
import { FallBackPage, ThemeModeWrapper } from "@highway/design-system";

export default function Error() {
    return (
        <ThemeModeWrapper>
            <FallBackPage page="error" />
        </ThemeModeWrapper>
    );
}
